import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const headerBack = style({
  flexShrink: 0,
  marginRight: space.s12,
});
